import fenv from "@bimproject/fenv";
import i18n from "i18next";
import locize from "i18next-locize-backend";
import { initReactI18next } from "react-i18next";

import pkg from "../../../package.json";

i18n
    .use(locize)
    .use(initReactI18next)
    .init(
        {
            debug: fenv.NODE_ENV === "development",
            fallbackLng: "en",
            fallbackNS: "common",
            interpolation: {
                escapeValue: false,
            },
            lng: "en",
            ns: [
                pkg.name,
                "common",
            ],
            backend: {
                projectId: "16967bf8-9310-48a2-a4c1-0d267c4f73af",
                referenceLng: "en",
            },
        }
    );

export default i18n;
